import { push } from 'redux-first-history'
import { all, call, put, takeEvery } from 'redux-saga/effects'

import { getOverviewPath } from '@app/modules/Overview'
import SDK from '@app/SDK'

import AuthAction from './actions'
import { publishEndedAuthSession } from './authSessionBroadcast'
import { clearAuthSessionRecord, writeAuthSessionRecord } from './authSessionRecord'
import { LOGIN_LAWYER, LOGOUT } from './constants'
import { LogoutReason } from './models'

export function* loginLawyer({ meta }): Generator<unknown, void, any> {
  try {
    const response = yield SDK.serviceManager.lawyerLogin({
      email: meta.email,
      password: meta.password
    })
    const {
      token,
      refreshToken,
      user: { id }
    } = response.data as {
      token: string
      refreshToken?: string
      user: { id: number }
    }

    const role = 'LAWYER'

    if (refreshToken) {
      yield call(writeAuthSessionRecord, { token, refreshToken })
    }

    yield put(AuthAction.onLoginSuccess({ id, token, refreshToken, role }))
    yield put(push(getOverviewPath()))
  } catch (error) {
    console.error(error)
    yield put(AuthAction.onLoginError(error))
  }
}

export function* logout({ payload }: { payload?: { reason?: LogoutReason } }) {
  yield call(clearAuthSessionRecord)

  if (payload?.reason !== LogoutReason.ANOTHER_TAB_ENDED_THE_SESSION) {
    yield call(publishEndedAuthSession)
  }
}

export function* authSaga() {
  yield all([yield takeEvery<any>(LOGIN_LAWYER, loginLawyer), yield takeEvery<any>(LOGOUT, logout)])
}
